import ContasPagarGraficos from './ContasPagarGraficos';

export default ContasPagarGraficos;
